import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CapitalCasePipe} from "../../../../pipes/capital-case.pipe";

@Component({
    selector: 'employment-detail-row',
    templateUrl: './employment-detail-row.component.html',
    styleUrls: ['./employment-detail-row.component.scss'],
    imports: [CommonModule, CapitalCasePipe]
})
export class EmploymentDetailRowComponent {
    @Input() label: string;
    @Input() value: any;
    @Input() missing: boolean | null = null;
    @Input() valueClass: string | null = null;
    @Input() capitalCase: boolean = false;
    @Input() upperCase: boolean = false;

    get isMissing(): boolean {
        if (this.missing !== null && this.missing !== undefined) return !!this.missing;
        return this.value == null || this.value === '';
    }
}
